import {
	openMask,
	closeMask,
	openError
} from '../mainModule/action';
import Axios from 'core/axios';
import Rest from 'core/rest';
import { getLocale } from 'core/i18n';
export const HOME_SEARCH_BOOKINGS_SUCCESS = 'HOME_SEARCH_BOOKINGS_SUCCESS';
export const HOME_CLEAN_BOOKINGS = 'HOME_CLEAN_BOOKINGS';
export const HOME_GET_BOOKING_DATA_SUCCESS = 'HOME_GET_BOOKING_DATA_SUCCESS';
export const HOME_CLEAN_BOOKING_DATA = 'HOME_CLEAN_BOOKING_DATA';

export const searchBookings = (data, tab) => {
	return (dispatch) => {
		dispatch(openMask());
		Axios.post(Rest.booking.postBooking(), data)
			.then((response) => {
				dispatch(closeMask());
				return dispatch({
					type: HOME_SEARCH_BOOKINGS_SUCCESS,
					data: response.data,
					tab
				});
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
};

export const cleanBookings = () => {
	return (dispatch) => {
		dispatch({
			type: HOME_CLEAN_BOOKINGS
		});
	};
};

export const getBooking = (recordLocator) => {
	return (dispatch) => {
		dispatch(openMask());
		Axios.get(Rest.booking.getBooking('recordLocator', recordLocator))
			.then((response) => {
				dispatch(closeMask());
				console.log(response);
				return dispatch({
					type: HOME_GET_BOOKING_DATA_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
};

export const cleanBookingData = () => {
	return (dispatch) => {
		dispatch({
			type: HOME_CLEAN_BOOKING_DATA
		});
	};
};

export const getBookingPDF = (pnr, locale) => {
	return (dispatch) => {
		dispatch(openMask());
		var request = new XMLHttpRequest();
		request.open('GET', Rest.booking.getBookingPDF(pnr, locale), true);
		request.setRequestHeader('Authorization', JSON.parse(sessionStorage.getItem('user')).token);
		request.responseType = 'blob';
		request.onload = function (e) {
			if (this.status === 200) {
				var file = window.URL.createObjectURL(this.response);
				window.open(file);
				dispatch(closeMask());
			}else{
				dispatch(closeMask());
				return dispatch(openError(this.response.error));
			};
		};
		request.send();
	};
};

export const getPortalToken = (pnr, mode, urlParameter) => {
	return (dispatch) => {
		dispatch(openMask());
		Axios.post(Rest.session.postPortal(pnr))
			.then((response) => {
				dispatch(closeMask());
				switch (mode) {
					case 'ibe':
						setTimeout(() => {
							window.open(`${Rest.directUrl.IBEUrl}/?token=${response.data.token}${urlParameter}`);
						}, 10);
						break;
					case 'mmb':
						setTimeout(() => {
							window.open(`${Rest.directUrl.MMBUrl}/?lang=${getLocale()}&token=${response.data.token}`);
						}, 10);
						break;
					default:
						break;
				}
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
};
